<template>
  <v-card>
    <v-toolbar color="#1B5E20" elevation="0">
      <v-btn
        icon
        dark
        @click.native="close"
        color="white"
        elevation="0"
        class="white--text"
        large
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-toolbar-title class="white--text">Your Shopping Cart!</v-toolbar-title>
    </v-toolbar>

    <!-- <v-divider></v-divider> -->
    <v-card class="mx-auto my-12" max-width="1000" elevation="0">
      <v-container fluid>
        <div v-if="countCart === 0">
          <v-alert outlined color="warning" icon="mdi-cart-off">
            Empty shopping basket!
          </v-alert>
        </div>

        <v-list three-line v-if="countCart > 0">
          <template v-for="(item, index) in carts">
            <v-list-item :key="'cart' + index">
              <v-list-item-avatar>
                <v-img :src="getImage('/' + item.cover)"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-html="item.title"></v-list-item-title>

                <v-list-item-title>
                  Rp. {{ item.price.toLocaleString("id-ID") }} ({{ item.weight }} gr)
                  <span style="float: right">
                    <v-btn icon @click.stop="removeCart(item)" color="white" large>
                      <v-icon dark color="error">mdi-minus-circle</v-icon>
                    </v-btn>
                    {{ item.quantity }}
                    <v-btn icon @click.stop="addCart(item)" color="white" large>
                      <v-icon dark color="success">mdi-plus-circle</v-icon>
                    </v-btn>
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <v-card-text>
          <v-layout wrap>
            <v-flex pa-1 xs6>
              Total Price ({{ totalQuantity }} items)<br />
              <span class="title">Rp. {{ totalPrice.toLocaleString("id-ID") }}</span>
            </v-flex>
            <v-flex pa-1 xs6 text-right>
              <v-btn
                @click="checkout"
                :disabled="totalQuantity == 0"
                rounded
                color="#1B5E20"
                outlined
                elevation="5"
                large
              >
                <v-icon>mdi-cart-arrow-right</v-icon> &nbsp; Checkout
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-container>
    </v-card>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "cart",
  computed: {
    ...mapGetters({
      carts: "cart/carts",
      countCart: "cart/count",
      totalPrice: "cart/totalPrice",
      totalQuantity: "cart/totalQuantity",
      totalWeight: "cart/totalWeight",
      totalStock: "cart/totalStock",
    }),
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      addCart: "cart/add",
      removeCart: "cart/remove",
      setCart: "cart/set",
    }),
    checkout() {
      this.close();
      //this.$router.push({ path: "/checkout" });
      this.$router.push({ path: "/deliveryDestination" });
    },
    close() {
      this.$emit("closed", false);
    },
  },
};
</script>
